import React, { useContext } from 'react';
import {
    CTAConfiguration,
    KontentRichText,
    KontentStringValue,
} from '../../../types/KontentProps';
import { PageMetadataContext } from '../../templates/PageMetaDataContext';
import SupportSearchResults from './SupportSearchResults';
import { graphql } from 'gatsby';

export interface SupportSearchResultsProps extends CTAConfiguration {
    kontentItemId?: string;
    content_type_filter_label: KontentStringValue;
    product_type_filter_label: KontentStringValue;
    topic_type_filter_label: KontentStringValue;
    filter_cta_label: KontentStringValue;
    no_results_found_messaging: KontentRichText;
}

const SupportSearchResultsContainer: React.FC<SupportSearchResultsProps> = ({
    ...props
}) => {
    const pageMetadata = useContext(PageMetadataContext);

    return (
        <SupportSearchResults
            {...props}
            term={pageMetadata?.location?.state?.searchTerm}
            preferredLanguage={pageMetadata?.preferredLanguage}
        />
    );
};

export default SupportSearchResultsContainer;

export const fragmentSupportSearchResults = graphql`
    fragment SupportSearchResults on kontent_item_component___support_search {
        elements {
            content_type_filter_label {
                value
            }
            product_type_filter_label {
                value
            }
            topic_type_filter_label {
                value
            }
            filter_cta_label {
                value
            }
            no_results_found_messaging {
                ...kontentRichText
            }
        }
    }
`;
